<div class="page page-servico" itemscope itemtype="https://schema.org/Product">
  <div class="container-servico">
    <div class="content-body">
      <div *ngIf="response.status == 1"> 
        <div class="photos" class="wow fadeIn" data-wow-delay="0.5s">    
          <produto-page-fotos [fotos]="fotos" [produto]="produto"></produto-page-fotos>
        </div> 
        <breadcrumbs [isFavorito]="isFavorito" [produtoId]="produto.id" btnSave='true' home="false" [itens]="itensBreadcrumbs"></breadcrumbs> 
        <div class="page-content"> 
          <div class="page-title mobile-center">
            <div class="container">
              <h1 class="page-title-h1 wow slideInDown" data-wow-delay="0.5s">{{produto.nome}}</h1>
            </div>
          </div>
          <div class="container"> 
            <div class="box-content-header">
              <div class="row row-content">
                <div class="col-md-8 wow fadeIn" data-wow-delay="1s">
                  <div class="section section-resumo">   
                    <div class="section-content">
                      <span class="id" *ngIf="produto.manage_id != null">Código: {{produto.manage_id}}</span> 
                    </div> 
                  </div> 
                  <div class="linha-divisor"></div>
                  <article class="text-article-html" [innerHtml]="produto.descricao | safeHtml"></article>
                  <div class="section-informacoes" *ngIf="produto.mostrar_informacao">
                    <h3>Informações</h3>
                    <article [innerHtml]="produto.descritivo_servico | safeHtml"></article>
                  </div>  
                </div> 
                <div class="col-md-4">
                  <div class="box-card wow slideInUp" data-wow-delay="0.5s">
                    <div class="dm-card content-right"> 
                      <div class="content">  
                        <div class="box-item box-item-valor">
                          <div class="center">  
                            <produto-item-valor class="center" [valor]="produto.menor_tarifa" [servico]="produto" template="servico"></produto-item-valor>
                          </div>  
                        </div>
                        <div class="box-item content-carrinho" *ngIf="!produto.vender_offline && produto.manage_id !== null">
                          <div class="box-item box-info" *ngIf="dias != null">
                            <img width="20px" defaultImage="/images/pixel/bg.png" lazyLoad="/images/template/icons/date.svg" alt="Date" />
                            <span>{{dias}}</span>
                          </div> 
                          <div class="box-item box-info" *ngIf="produto.duracao != null">
                            <img width="20px" defaultImage="/images/pixel/bg.png" lazyLoad="/images/template/icons/duracao.svg" alt="Duração" />
                            <span>{{produto.duracao | formatDuracao}} / duração aproximada</span>
                          </div>  
                          <div class="box-item-cart-edit" *ngIf="servicoCart !== null">
                            <dm-cart-box-edit [configuracaoLoja]="configuracao_loja" [servico]="servicoCart"></dm-cart-box-edit>
                          </div> 
                          <div class="box-item-cart-add" *ngIf="servicoCart === null">
                            <btn-add-cart [emailSugestao]="emailSugestao" [idCart]="idCart" [email]="email" [horarios]="horarios" [servico]="produto" [categoria]="categoria" [configuracaoLoja]="configuracao_loja" [macroRegiao]="macro_regiao"></btn-add-cart>
                            <partial-compra-segura></partial-compra-segura>
                          </div> 
                        </div>  
                        <div class="content-carrinho" *ngIf="produto.vender_offline || produto.manage_id === null">
                          <produto-venda-offline [servico]="produto" [configuracaoLoja]="configuracao_loja"></produto-venda-offline>
                        </div>
                      </div>  
                    </div>
                  </div>
                </div>  
              </div>
            </div> 
            <img *ngIf="produtos_relacionados.length > 0 || caracteristicas.length > 0" class="img-hero-1 wow slideInLeft" data-wow-delay="0.4s" imageDefault="/images/pixel/bg.png" lazyLoad="/images/template/logo/costa-azul.png" alt="Costa Azul" />
            <section class="section section-produto-incluso" *ngIf="caracteristicas.length > 0">
              <produto-incluso [data]="caracteristicas"></produto-incluso>
            </section>
            <section class="section section-produto-faq" *ngIf="faq.length > 0">
              <produto-faq [data]="faq"></produto-faq>
            </section>
            <section class="section section-produto-avaliacao" *ngIf="avaliacao.nota > 0">
              <produto-avaliacao [data]="avaliacao"></produto-avaliacao>
            </section>
          </div> 
          <section class="section section-veja-tambem" *ngIf="produtos_relacionados.length > 0">
            <div class="section-title"> 
              <div class="content">
                <div class="container">
                  <h2 class="section-title-h2 text-center wow fadeIn" data-wow-delay="0.2s">Veja mais experiências</h2>
                  <h3 class="section-title-h3 text-center wow fadeIn" data-wow-delay="0.5s">Faça da sua viagem uma experiência completa :)</h3>
                </div>  
              </div>
            </div> 
            <img class="img-onda-3" imageDefault="/images/pixel/bg.png" lazyLoad="/images/template/onda/onda-3.svg" width="100%" />
            <div class="section-content"> 
              <div class="container">  
                <div class="row">  
                  <div class="col-md-3 wow slideInUp" data-wow-delay="0.1s" *ngFor="let item of produtos_relacionados">
                    <produto-item-two [data]="item"></produto-item-two>
                  </div>
                </div>
              </div>  
            </div> 
            <img class="img-onda-2" imageDefault="/images/pixel/bg.png" lazyLoad="/images/template/onda/onda-2.svg" width="100%" /> 
            <div class="faixa-white"></div> 
          </section>
          <modulo posicao="whatsapp" template="fixo"></modulo>   
      </div>  
      <div *ngIf="response.status == 500">
        <div class="container">
          <page-error [data]="response.data" (reload)="getData()"></page-error>
        </div>  
      </div>
    </div> 
  </div>
</div>    
<loader *ngIf="loader"></loader> 
  